import React from 'react';

interface Project {
  id: string;
  time: string;
  title: string;
  isChecked?: boolean;
}

const projects: Project[] = [
  { id: '1', time: '05:48AM', title: 'Are there any open non-administrative accounts in the...', isChecked: false },
  { id: '2', time: '05:48AM', title: 'Are there any open non-administrative accounts in the...', isChecked: false },
  { id: '3', time: '05:48AM', title: 'Are there any open non-administrative accounts in the...', isChecked: false },
  { id: '4', time: '05:48AM', title: 'Are there any open non-administrative accounts in the...', isChecked: false },
  { id: '5', time: '05:48AM', title: 'Are there any open non-administrative accounts in the...', isChecked: false },
];

const ProjectSidebar: React.FC = () => {
  return (
    <aside
      className="bg-white border border-[#76BCCB] rounded-xl overflow-hidden flex flex-col shadow-sm"
      style={{
        width: '267px',
        height: '671.5px',
      }}
    >
      {/* Header */}
      <div className="flex justify-between items-center px-4 pt-4 pb-3 border-b border-gray-100">
        <h3 className="text-[15px] font-semibold text-gray-900">Projects (7)</h3>
        <button className="text-gray-400 hover:text-gray-600">
          <svg xmlns="http://www.w3.org/2000/svg" className="w-5 h-5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth={2}
              d="M5 12h.01M12 12h.01M19 12h.01M6 12a2 2 0 11-4 0 2 2 0 014 0zm7 0a2 2 0 11-4 0 2 2 0 014 0zm7 0a2 2 0 11-4 0 2 2 0 014 0z"
            />
          </svg>
        </button>
      </div>

      {/* New Project */}
      <div className="mx-3 mt-3 mb-3 bg-gray-50 hover:bg-gray-100 border border-gray-200 rounded-lg p-3 cursor-pointer transition-colors">
        <div className="flex items-center gap-2 text-gray-700">
          <div className="w-5 h-5 flex items-center justify-center border border-gray-300 rounded text-sm font-medium">+</div>
          <span className="font-medium text-sm">New Project</span>
        </div>
      </div>

      {/* Projects List */}
      <div className="flex-1 overflow-y-auto px-3 space-y-2 pb-4 custom-scrollbar">
        {projects.map((project) => (
          <div
            key={project.id}
            className="bg-white border border-gray-200 hover:border-gray-300 rounded-lg p-3 transition-all group"
            style={{ height: '82px' }}
          >
            <div className="flex items-start h-full gap-3">
              {/* Green Dot + Time (Horizontal) */}
              <div className="flex items-center gap-1.5 w-[68px] flex-shrink-0 pt-0.5">
                <div className="w-2 h-2 bg-emerald-500 rounded-full flex-shrink-0"></div>
                <span className="text-[10px] font-medium text-gray-500 whitespace-nowrap">{project.time}</span>
              </div>

              {/* Project Title */}
              <div className="flex-1 min-w-0 pr-3">
                <p className="text-sm text-gray-700 line-clamp-3 leading-tight">{project.title}</p>
              </div>

              {/* Checkbox */}
              <div className="flex-shrink-0 pt-1">
                <input type="checkbox" checked={project.isChecked} className="w-4 h-4 accent-blue-600 cursor-pointer" />
              </div>
            </div>
          </div>
        ))}
      </div>
    </aside>
  );
};

export default ProjectSidebar;
